import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  
  export const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart',
      },
    },
    scales: {
        y: {
            beginAtZero: true,
            max: 150,
            min: 0,
            grid: {
                borderDash: [8, 2],
                color: 'black',
                drawTicks: false
            },
            ticks: {
                color: 'black',
                padding: 17,
                stepSize: 25,
                callback: function (value, index, values) {
                    return "₦"+ value + "K";
                }
            },
        },
        x: {
            grid: {
                borderDash: [3, 0],
                color: 'white',
                drawTicks: false
            },
            ticks: {
                color: 'black',
                padding: 13,
            },
        }
    },
  };

const labels = ['week 1', 'week 2', 'week 3', 'week 4'];

  export const data = {
    labels,
    datasets: [
      {
        label: 'Income',
        data: [100, 50, 80],
        backgroundColor: '#40F35D',
        borderRadius: 8,
        barThickness : 25,
      },
      {
        label: 'Expenses',
        data: [15, 10, 120],
        backgroundColor: '#F11414',
        borderRadius: 8,
        barThickness : 25,
      },
    ],
  };

export default function BarChart(){


    return (
           <Bar  options={options} data={data}/>
    )
}
